import AkshitAvatar from '../images/akshit_avatar.png'
import NiviAvatar from '../images/nivi_avatar.png'
import { MarkerContent } from './content'

const AKSHIT_COLOR = '#60b533'
const NIVI_COLOR = '#009ec1'

const AKSHIT_MARKER_CONTENT = (
  <div className='akshit-marker'>
    <img src={AkshitAvatar} alt='Akshit' className='akshit-avatar' />
  </div>
)

const AKSHIT_MARKER_SMALL_CONTENT = (
  <div className='akshit-marker-small'>
    <img src={AkshitAvatar} alt='Akshit' className='akshit-avatar-small' />
  </div>
)

const NIVI_MARKER_CONTENT = (
  <div className='nivi-marker'>
    <img src={NiviAvatar} alt='Nivi' className='nivi-avatar' />
  </div>
)

const NIVI_MARKER_SMALL_CONTENT = (
  <div className='nivi-marker-small'>
    <img src={NiviAvatar} alt='Nivi' className='nivi-avatar-small' />
  </div>
)

const AKSHIT_NIVI_MARKER_CONTENT = (
  <div className='akshit-nivi-marker'>
    <img src={AkshitAvatar} alt='Akshit' className='akshit-nivi-akshit-avatar' />
    <img src={NiviAvatar} alt='Nivi' className='akshit-nivi-nivi-avatar' />
  </div>
)

const AKSHIT_POPUP_CONTENT = (title, location, description) => (
  <div>
    <div className='popup-header'>
      <img src={AkshitAvatar} alt='Akshit' className='akshit-avatar' />
      <h4>{title}</h4>
    </div>
    <p className='popup-location'>{location}</p>
    <p className='popup-description'>{description}</p>
  </div>
)

const NIVI_POPUP_CONTENT = (title, location, description) => (
  <div>
    <div className='popup-header'>
      <img src={NiviAvatar} alt='Nivi' className='nivi-avatar' />
      <h4>{title}</h4>
    </div>
    <p className='popup-location'>{location}</p>
    <p className='popup-description'>{description}</p>
  </div>
)

const AKSHIT_NIVI_POPUP_CONTENT = (title, location, description) => (
  <div className='popup'>
    <div className='popup-header'>
      <img src={AkshitAvatar} alt='Akshit' className='akshit-avatar' />
      <img src={NiviAvatar} alt='Nivi' className='nivi-avatar' style={{ marginLeft: -12 }} />
      <h4>{title}</h4>
    </div>
    <p className='popup-location'>{location}</p>
    <p className='popup-description'>{description}</p>
  </div>
)

export const MARKERS = [
  {
    id: 'akshit-pune',
    position: MarkerContent.akshit.pune.position,
    borderColor: AKSHIT_COLOR,
    popupContent: AKSHIT_POPUP_CONTENT(MarkerContent.akshit.pune.title, MarkerContent.akshit.pune.location, MarkerContent.akshit.pune.description),
    markerContent: AKSHIT_MARKER_CONTENT
  },
  {
    id: 'nivi-kakkanad',
    position: MarkerContent.nivi.kakkanad.position,
    borderColor: NIVI_COLOR,
    popupContent: NIVI_POPUP_CONTENT(MarkerContent.nivi.kakkanad.title, MarkerContent.nivi.kakkanad.location, MarkerContent.nivi.kakkanad.description),
    markerContent: NIVI_MARKER_CONTENT
  },
  {
    id: 'akshit-nagpur',
    position: MarkerContent.akshit.nagpur.position,
    borderColor: AKSHIT_COLOR,
    popupContent: AKSHIT_POPUP_CONTENT(MarkerContent.akshit.nagpur.title, MarkerContent.akshit.nagpur.location, MarkerContent.akshit.nagpur.description),
    markerContent: AKSHIT_MARKER_CONTENT
  },
  {
    id: 'nivi-navi-mumbai',
    position: MarkerContent.nivi.navimumbai.position,
    borderColor: NIVI_COLOR,
    popupContent: NIVI_POPUP_CONTENT(MarkerContent.nivi.navimumbai.title, MarkerContent.nivi.navimumbai.location, MarkerContent.nivi.navimumbai.description),
    markerContent: NIVI_MARKER_CONTENT
  },
  {
    id: 'nivi-mumbai',
    position: MarkerContent.nivi.mumbai.position,
    borderColor: NIVI_COLOR,
    popupContent: NIVI_POPUP_CONTENT(MarkerContent.nivi.mumbai.title, MarkerContent.nivi.mumbai.location, MarkerContent.nivi.mumbai.description),
    markerContent: NIVI_MARKER_CONTENT
  },
  {
    id: 'nivi-amsterdam',
    position: MarkerContent.nivi.amsterdam.position,
    borderColor: NIVI_COLOR,
    popupContent: NIVI_POPUP_CONTENT(MarkerContent.nivi.amsterdam.title, MarkerContent.nivi.amsterdam.location, MarkerContent.nivi.amsterdam.description),
    markerContent: NIVI_MARKER_CONTENT
  },
  {
    id: 'akshit-buldhana',
    position: MarkerContent.akshit.buldhana.position,
    borderColor: AKSHIT_COLOR,
    popupContent: AKSHIT_POPUP_CONTENT(MarkerContent.akshit.buldhana.title, MarkerContent.akshit.buldhana.location, MarkerContent.akshit.buldhana.description),
    markerContent: AKSHIT_MARKER_SMALL_CONTENT
  },
  {
    id: 'akshit-jalna',
    position: MarkerContent.akshit.jalna.position,
    borderColor: AKSHIT_COLOR,
    popupContent: AKSHIT_POPUP_CONTENT(MarkerContent.akshit.jalna.title, MarkerContent.akshit.jalna.location, MarkerContent.akshit.jalna.description),
    markerContent: AKSHIT_MARKER_SMALL_CONTENT
  },
  {
    id: 'nivi-losangeles',
    position: MarkerContent.nivi.losangeles.position,
    borderColor: NIVI_COLOR,
    popupContent: NIVI_POPUP_CONTENT(MarkerContent.nivi.losangeles.title, MarkerContent.nivi.losangeles.location, MarkerContent.nivi.losangeles.description),
    markerContent: NIVI_MARKER_CONTENT
  },
  {
    id: 'nivi-vietnam',
    position: MarkerContent.nivi.vietnam.position,
    borderColor: NIVI_COLOR,
    popupContent: NIVI_POPUP_CONTENT(MarkerContent.nivi.vietnam.title, MarkerContent.nivi.vietnam.location, MarkerContent.nivi.vietnam.description),
    markerContent: NIVI_MARKER_CONTENT
  },
  {
    id: 'nivi-miyarvalley',
    position: MarkerContent.nivi.miyarvalley.position,
    borderColor: NIVI_COLOR,
    popupContent: NIVI_POPUP_CONTENT(MarkerContent.nivi.miyarvalley.title, MarkerContent.nivi.miyarvalley.location, MarkerContent.nivi.miyarvalley.description),
    markerContent: NIVI_MARKER_CONTENT
  }, 
  {
    id: 'akshit-beltarodi',
    position: MarkerContent.akshit.beltarodi.position,
    borderColor: AKSHIT_COLOR,
    popupContent: AKSHIT_POPUP_CONTENT(MarkerContent.akshit.beltarodi.title, MarkerContent.akshit.beltarodi.location, MarkerContent.akshit.beltarodi.description),
    markerContent: AKSHIT_MARKER_SMALL_CONTENT
  },
  {
    id: 'akshit-hingna',
    position: MarkerContent.akshit.hingna.position,
    borderColor: AKSHIT_COLOR,
    popupContent: AKSHIT_POPUP_CONTENT(MarkerContent.akshit.hingna.title, MarkerContent.akshit.hingna.location, MarkerContent.akshit.hingna.description),
    markerContent: AKSHIT_MARKER_SMALL_CONTENT
  },
  {
    id: 'akshit-akola',
    position: MarkerContent.akshit.akola.position,
    borderColor: AKSHIT_COLOR,
    popupContent: AKSHIT_POPUP_CONTENT(MarkerContent.akshit.akola.title, MarkerContent.akshit.akola.location, MarkerContent.akshit.akola.description),
    markerContent: AKSHIT_MARKER_SMALL_CONTENT
  },
  {
    id: 'akshit-panchawati',
    position: MarkerContent.akshit.panchawati.position,
    borderColor: AKSHIT_COLOR,
    popupContent: AKSHIT_POPUP_CONTENT(MarkerContent.akshit.panchawati.title, MarkerContent.akshit.panchawati.location, MarkerContent.akshit.panchawati.description),
    markerContent: AKSHIT_MARKER_SMALL_CONTENT
  },
  {
    id: 'akshit-hinjewadi',
    position: MarkerContent.akshit.hinjewadi.position,
    borderColor: AKSHIT_COLOR,
    popupContent: AKSHIT_POPUP_CONTENT(MarkerContent.akshit.hinjewadi.title, MarkerContent.akshit.hinjewadi.location, MarkerContent.akshit.hinjewadi.description),
    markerContent: AKSHIT_MARKER_SMALL_CONTENT
  },
  {
    id: 'akshit-mcleodganj',
    position: MarkerContent.akshit.mcleodganj.position,
    borderColor: AKSHIT_COLOR,
    popupContent: AKSHIT_POPUP_CONTENT(MarkerContent.akshit.mcleodganj.title, MarkerContent.akshit.mcleodganj.location, MarkerContent.akshit.mcleodganj.description),
    markerContent: AKSHIT_MARKER_SMALL_CONTENT
  },
  {
    id: 'akshit-manali',
    position: MarkerContent.akshit.manali.position,
    borderColor: AKSHIT_COLOR,
    popupContent: AKSHIT_POPUP_CONTENT(MarkerContent.akshit.manali.title, MarkerContent.akshit.manali.location, MarkerContent.akshit.manali.description),
    markerContent: AKSHIT_MARKER_SMALL_CONTENT
  },
   {
    id: 'akshit-coorg',
    position: MarkerContent.akshit.coorg.position,
    borderColor: AKSHIT_COLOR,
    popupContent: AKSHIT_POPUP_CONTENT(MarkerContent.akshit.coorg.title, MarkerContent.akshit.coorg.location, MarkerContent.akshit.coorg.description),
    markerContent: AKSHIT_MARKER_SMALL_CONTENT
  },
  {
    id: 'akshit-ooty',
    position: MarkerContent.akshit.ooty.position,
    borderColor: AKSHIT_COLOR,
    popupContent: AKSHIT_POPUP_CONTENT(MarkerContent.akshit.ooty.title, MarkerContent.akshit.ooty.location, MarkerContent.akshit.ooty.description),
    markerContent: AKSHIT_MARKER_SMALL_CONTENT
  },
  {
    id: 'akshit-varca',
    position: MarkerContent.akshit.varca.position,
    borderColor: AKSHIT_COLOR,
    popupContent: AKSHIT_POPUP_CONTENT(MarkerContent.akshit.varca.title, MarkerContent.akshit.varca.location, MarkerContent.akshit.varca.description),
    markerContent: AKSHIT_MARKER_SMALL_CONTENT
  },
  {
    id: 'akshit-mysore',
    position: MarkerContent.akshit.mysore.position,
    borderColor: AKSHIT_COLOR,
    popupContent: AKSHIT_POPUP_CONTENT(MarkerContent.akshit.mysore.title, MarkerContent.akshit.mysore.location, MarkerContent.akshit.mysore.description),
    markerContent: AKSHIT_MARKER_SMALL_CONTENT
  },
  {
    id: 'akshit-bangalore',
    position: MarkerContent.akshit.bangalore.position,
    borderColor: AKSHIT_COLOR,
    popupContent: AKSHIT_POPUP_CONTENT(MarkerContent.akshit.bangalore.title, MarkerContent.akshit.bangalore.location, MarkerContent.akshit.bangalore.description),
    markerContent: AKSHIT_MARKER_SMALL_CONTENT
  },
  {
    id: 'akshit-nivi-westend-2023',
    position: MarkerContent.akshit_nivi.westend_2023.position,
    borderColor: NIVI_COLOR,
    popupContent: AKSHIT_NIVI_POPUP_CONTENT(MarkerContent.akshit_nivi.westend_2023.title, MarkerContent.akshit_nivi.westend_2023.location, MarkerContent.akshit_nivi.westend_2023.description),
    markerContent: AKSHIT_NIVI_MARKER_CONTENT
  },
  {
    id: 'nivi-bhis-mumbai',
    position: MarkerContent.nivi.bhis_mumbai.position,
    borderColor: NIVI_COLOR,
    popupContent: NIVI_POPUP_CONTENT(MarkerContent.nivi.bhis_mumbai.title, MarkerContent.nivi.bhis_mumbai.location, MarkerContent.nivi.bhis_mumbai.description),
    markerContent: NIVI_MARKER_SMALL_CONTENT
  },
  {
    id: 'nivi-vu-mumbai',
    position: MarkerContent.nivi.vu_mumbai.position,
    borderColor: NIVI_COLOR,
    popupContent: NIVI_POPUP_CONTENT(MarkerContent.nivi.vu_mumbai.title, MarkerContent.nivi.vu_mumbai.location, MarkerContent.nivi.vu_mumbai.description),
    markerContent: NIVI_MARKER_SMALL_CONTENT
  },
  {
    id: 'nivi-pune-symbiosys',
    position: MarkerContent.nivi.pune_symbiosys.position,
    borderColor: NIVI_COLOR,
    popupContent: NIVI_POPUP_CONTENT(MarkerContent.nivi.pune_symbiosys.title, MarkerContent.nivi.pune_symbiosys.location, MarkerContent.nivi.pune_symbiosys.description),
    markerContent: NIVI_MARKER_SMALL_CONTENT
  }
]